var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTasksViewTask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tasks_view_task"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 299.82,
    cy: 300,
    r: 299.73,
    transform: "translate(-124.32 299.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M500.67,301.61S411.92,426.43,302.44,426.43,104.22,298.05,104.22,298.05,193,169.67,302.44,169.67,500.67,301.61,500.67,301.61Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300.67,
    cy: 298.89,
    r: 75.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 300.67,
    cy: 298.89,
    r: 42.22
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksViewTask);
export default __webpack_public_path__ + "static/media/tasks_view_task.82840a82c45fd78e8acd16f317550cb7.svg";
export { ForwardRef as ReactComponent };